export default {
  setAccessToken(state, { accessToken = '' }) {
    state.accessToken = accessToken;
    localStorage.accessToken = accessToken;
  },

  setIsPush(state, payload) {
    state.userData.userNo = payload.userNo;
    state.userData.isPush = payload.isPush;
  },

  setUserData(state, entity) {
    state.userData = entity;
    state.student = entity.student; // 학부모의 student array
  },

  setErrorMessage(state, message = '') {
    state.message = message;
  },

  resetUserData(state) {
    state.userData = {};
    state.accessToken = '';
    delete localStorage.accessToken;
    delete localStorage.userData;
  },

  storeLogin(state, { userData = {}, accessToken = '', message = '' }) {
    state.userData = userData;
    state.message = message;
    localStorage.setItem('userData', JSON.stringify(userData));
    localStorage.setItem('accessToken', accessToken);
  },

  storeLogout(state) {
    state.accessToken = null;
    state.userData = null;
    delete localStorage.accessToken;
    delete localStorage.userData;
    // location.reload()
  },

  setMainPageInfo(state, { studyList = [], paymentList = [], noticeList = [], bannerList = [] }) {
    state.bannerList = bannerList;
    state.noticeList = noticeList;
    state.paymentList = paymentList;
    state.studyList = studyList;
  },

  setStudyList(state, studyList = []) {
    state.studyList = studyList;
  },

  setAuthCode(state, authCode) {
    state.authCode = authCode;
  }
};
